let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hsbPE")).then(() => parcelRequire('jQRrP'));